import { MobileAppAuthPinFingerprintBackdropStyled } from "./styled/MobileAppAuthPinFingerprintBackdropStyled";
import { BinIcon } from "../../../../components/icon/Icon";
import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext";
import useEffectOnce from "../../../../hooks/useEffectOnce";
import { LOG_AF_EVENT_NAMES } from "../../../../app/appConstants";
import { useLocationProviderContext } from "../../../../providers/LocationProvider/LocationProviderContext";
import { connect } from "react-redux";
import { logAppsflyerAction } from "../../../../app/appActions";

function MobileAppAuthPinFingerprintBackdrop(props) {
    const {logAppsflyer} = props;
    const {prevLocation} = useLocationProviderContext();

    const {getLangPath} = useLangContext();
    useEffectOnce(() => {
        logAppsflyer({
            name: LOG_AF_EVENT_NAMES.LOGIN_FINGERPRINT_SHOWN,
            payload: { source: prevLocation.pathname || 'None' },
        });
    });

    return <MobileAppAuthPinFingerprintBackdropStyled>
        <BinIcon name="IcFingerprint" style={{fontSize: '80px'}}/>
        <p className="color-white mt-40">{getLangPath('lite_version.sign_up.fingerprint')}</p>
        <p className="text-secondary mt-40">{getLangPath('lite_version.sign_up.enter_pin')}</p>
    </MobileAppAuthPinFingerprintBackdropStyled>
}

const mapDispatchToProps = (dispatch) => ({
    logAppsflyer: payload => dispatch(logAppsflyerAction(payload)),
});

export default connect(null, mapDispatchToProps)(MobileAppAuthPinFingerprintBackdrop);
